function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { debounce } from '@cloud-sn/v-utils';
import { buildComponentName } from '../utils';
import Checkbox from '../checkbox';
export default {
  name: buildComponentName('TransferListItem'),
  props: {
    prefixCls: {
      type: String,
      default: 'ux-transfer-list-content-item'
    },
    checked: {
      type: Boolean,
      default: false
    },
    item: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    title: {
      type: String,
      default: ''
    },
    label: {
      type: [String, Object, Array],
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    classes: function classes() {
      var _ref;

      var prefixCls = this.prefixCls,
          item = this.item,
          disabled = this.disabled;
      return _ref = {}, _defineProperty(_ref, prefixCls, true), _defineProperty(_ref, "".concat(prefixCls, "-disabled"), !!item.disabled || disabled), _ref;
    }
  },
  created: function created() {
    // fixed, 点击 checkbox label会同时触发两次click,一个label的,一个input的
    this.onDebounceClick = debounce(this.onClick, 10);
  },
  methods: {
    onClick: function onClick(e) {
      var item = this.item,
          disabled = this.disabled;
      e.stopPropagation();

      if (item.disabled || disabled) {
        return;
      }

      this.$emit('click', item);
    }
  },
  render: function render() {
    var h = arguments[0];
    var classes = this.classes,
        checked = this.checked,
        title = this.title,
        item = this.item,
        label = this.label,
        onDebounceClick = this.onDebounceClick,
        disabled = this.disabled;
    return h("li", {
      "class": classes,
      "attrs": {
        "title": title
      },
      "on": {
        "click": onDebounceClick
      }
    }, [h(Checkbox, {
      "attrs": {
        "control": true,
        "checked": checked,
        "disabled": item.disabled || disabled
      }
    }), h("span", [label])]);
  }
};